import React from 'react'

interface ICollapseNavigationButton {
    onToggleNavigation: () => void
    isCollapsed: boolean
}

interface State {}

export class CollapseNavigationButton extends React.PureComponent<ICollapseNavigationButton> {
    constructor(props: ICollapseNavigationButton) {
        super(props)
    }

    public render() {
        const { isCollapsed, onToggleNavigation } = this.props

        const icon = isCollapsed ? 'fa-long-arrow-right' : 'fa-long-arrow-left'

        return (
            <button onClick={onToggleNavigation} className="sideNav-button">
                <i className={`fa ${icon}`} aria-hidden="true"></i>
                <span className="sideNav-label">Collapse</span>
            </button>
        )
    }
}

export default CollapseNavigationButton
